// extracted by mini-css-extract-plugin
module.exports = {"trigger":"Tooltip_trigger__dGNcT","content":"Tooltip_content__Iy19_","noInverse":"Tooltip_noInverse__R_5Me","noCenter":"Tooltip_noCenter__m75S1","compact":"Tooltip_compact__uOiLU"};